import type { UserProfile } from 'generated/openapi';
import { memo } from 'react';

import { ProfileOverviewCard } from '@/features/profile/components/profileOverviewCard';
import { useGetMyProfile } from '@/features/profile/hooks/useGetMyProfile';
import type { Rarity } from '@/shared/types/rarity';

const cardRarity: Rarity = 'LEGENDARY';

export const MyProfileCard = memo(function MyProfileCard() {
  const { data: profile } = useGetMyProfile({
    options: {
      select: data => data.profile as UserProfile,
    },
  });

  const {
    userId,
    pictureUrl,
    isPremium,
    valorantRank,
    valorantRankedQueueRate,
    valorantMostPlayedAgents,
    displayName,
    age,
    status,
    badges,
    isReadyToPlay,
    languages,
    onlineStatus,
    valorantServers,
    valorantRegion,
  } = profile;

  const reputationBadge = badges[0];

  return (
    <ProfileOverviewCard.Root
      rarity={cardRarity}
      isPremium={isPremium}
      corners="bottom"
      className="mx-auto max-h-165 max-w-100"
    >
      <ProfileOverviewCard.Container>
        <ProfileOverviewCard.ImageContainer isPremium={isPremium}>
          <ProfileOverviewCard.Avatar
            pictureUrl={pictureUrl}
            isPremium={isPremium}
          />
          <ProfileOverviewCard.ImageOverlay
            name={displayName}
            age={age}
            bio={status}
            languages={languages}
            onlineStatus={onlineStatus}
            isReadyToPlay={isReadyToPlay}
            userId={userId}
            reputationBadge={reputationBadge}
          />
        </ProfileOverviewCard.ImageContainer>
        <ProfileOverviewCard.Content>
          <ProfileOverviewCard.GameInfo
            valorantRank={valorantRank}
            rankedQueueRate={valorantRankedQueueRate}
            agentIds={valorantMostPlayedAgents}
          />
          <ProfileOverviewCard.CompatibilityDetails
            rarity={cardRarity}
            percent={1}
            vibeMatch={1}
            playstyleMatch={1}
          />
          <ProfileOverviewCard.ConnectionInfo
            servers={valorantServers}
            region={valorantRegion}
            pingMs={0}
          />
        </ProfileOverviewCard.Content>
      </ProfileOverviewCard.Container>
    </ProfileOverviewCard.Root>
  );
});
